import React, { useEffect, useState } from "react";
import { authImageUrl } from "../../lib/storage";

/**
 * Auth-aware image: uses the ?auth=token query so plain <img> works.
 * Falls back to children (placeholder) when src is missing.
 */
export default function AuthImage({ src, alt = "", className = "", fallback = null, ...rest }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    setUrl(src ? authImageUrl(src) : null);
  }, [src]);

  if (!url || failed) return fallback;
  return <img src={url} alt={alt} className={className} onError={() => setFailed(true)} {...rest} />;
}
